import React from 'react';
import { Image } from 'react-native';
import sentryMobileLogo from '../../assets/logotype_sentry_mobile_color.png';
import { useTheme } from '../../theme';

// The logotype is brand blue; dark themes tint it with the accent colour so it stays readable.
// style overrides the size (e.g. the smaller logo in the page header).
const Logo = ({ style }) => {
	const { theme: { ui } } = useTheme();

	return (
		<Image
			style={[{ width: 240, height: 30, resizeMode: 'contain', tintColor: ui.isDark ? ui.colors.accent : undefined }, style]}
			source={sentryMobileLogo}
			accessibilityRole="image"
			accessibilityLabel="Sentry mobile"
		/>
	);
};

export default React.memo(Logo);
